const { createContext, useContext, useState, useEffect } = require('react');

const CurrencyContext = createContext(null);

export const CurrencyProvider = ({ children }) => {
    const [currency, setCurrency] = useState('USD');
    const [currencies, setCurrencies] = useState([]);

    const loadCurrencyData = () => {
        const currency = window.localStorage.getItem('currency');
        if (currency) {
            setCurrency(currency);
        } else {
            window.localStorage.setItem('currency', 'USD');
            setCurrency('USD');
        }
    };

    useEffect(() => {
        loadCurrencyData();
    }, []);

    return (
        <CurrencyContext.Provider
            value={{
                currency,
                currencies,
                setCurrency,
                setCurrencies,
            }}>
            {children}
        </CurrencyContext.Provider>
    );
};

CurrencyProvider.displayName = 'CurrencyProvider';

export const useCurrency = () => useContext(CurrencyContext);
